/**
 * Securities Tab
 * Displays securities overview and enrichment workflow
 */

import React, { useState } from "react";

import { SecuritiesOverview, SecuritiesEnrichment } from "../securities/components";

export const SecuritiesTab: React.FC = () => {
  const [activeView, setActiveView] = useState<"enrichment" | "overview">("overview");

  return (
    <div className="space-y-6">
      {/* View Toggle */}
      <div className="flex space-x-2 border-b border-slate-700 pb-4">
        <button
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
            activeView === "overview"
              ? "bg-tracq-bright-blue/20 text-tracq-bright-blue border border-tracq-bright-blue/30"
              : "text-slate-400 hover:text-white hover:bg-slate-600/30"
          }`}
          onClick={() => {
            setActiveView("overview");
          }}
        >
          Overview
        </button>
        <button
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
            activeView === "enrichment"
              ? "bg-tracq-bright-blue/20 text-tracq-bright-blue border border-tracq-bright-blue/30"
              : "text-slate-400 hover:text-white hover:bg-slate-600/30"
          }`}
          onClick={() => {
            setActiveView("enrichment");
          }}
        >
          Enrichment
        </button>
      </div>

      {/* Content */}
      {activeView === "overview" ? <SecuritiesOverview /> : <SecuritiesEnrichment />}
    </div>
  );
};
